@if (order) {
  <div class="details">
    <div class="details__column">
      @if (order.parties && (order.parties.supplier || order.parties.shipper)) {
        @let party = order.parties.supplier || order.parties.shipper;
        <div class="details__column--label">Supplier</div>
        @if (party.name) {
          <span>{{ party.name }}</span>
        }
        @if (party.countryCode) {
          {{ party.countryCode }}
        }
      }
    </div>
    <div class="details__column">
      @if (order.parties && (order.parties.buyer || order.parties.consignee)) {
        @let party = order.parties.buyer || order.parties.consignee;
        <div class="details__column--label">Buyer</div>
        @if (party.name) {
          <span>{{ party.name }}</span>
        }
        @if (party.countryCode) {
          {{ party.countryCode }}
        }
      }
    </div>
    <div class="details__column">
      <div class="details__column--label">Goods Summary</div>
      @if (order.goods) {
        @if (order.goods.totalQuantity > 0) {
          <span class="details__column--value">{{ order.goods.totalQuantity }} PCS</span>
        }
        @if (order.goods.goodsDescription) {
          <span class="details__column--value">{{ order.goods.goodsDescription }}</span>
        }
      }
    </div>
    <div class="details__column">
      <div class="details__column--label">Transport Mode</div>
      <span>{{ order.transportMode }}</span>
    </div>
    <div class="details__column">
      <div class="details__column--label">Order No.</div>
      <span>{{ order.orderNo }}</span>
    </div>
    <div class="details__column">
      @if (order.orderReference) {
        <div class="details__column--label">Reference</div>
        <span>{{ order.orderReference }}</span>
      }
    </div>
    <div class="details__column--full">
      <div class="details__column--label">SGL Shipment No.</div>
      @if (order.shipmentNo) {
        @if (order.shipmentExists) {
          <a [routerLink]="['/overview', order.shipmentNo]">{{ order.shipmentNo }}</a>
        } @else {
          {{ order.shipmentNo }}
        }
      }
    </div>
    <div class="details__column">
      @if (order.reminderSent) {
        <div class="details__column--label">Reminder</div>
        <span>{{ order.reminderSent | dateTimeFormat }}</span>
        @if (order.reminderSentBy) {
          <span>{{ ' ' }}{{ order.reminderSentBy }}</span>
        }
      }
    </div>
    <div class="details__column">
      @if (order.exceptionStatus) {
        <div class="details__column--label">Exception Status</div>
        <span>{{ order.exceptionStatus }}</span>
      }
    </div>
    <div class="details__column--full">
      @if (order.booked) {
        <div class="details__column--label">Booked</div>
        <span>{{ order.booked }}</span>
      }
    </div>
    <div class="details__column">
      @if (order.houseNo) {
        @if (order.transportMode === 'Air') {
          <div class="details__column--label">HAWB</div>
        } @else {
          <div class="details__column--label">HBL</div>
        }
        <span>{{ order.houseNo }}</span>
      }
    </div>
    <div class="details__column">
      @if (order.masterNo && order.transportMode === 'Air') {
        <div class="details__column--label">AWB</div>
        <span>{{ order.houseNo }}</span>
      }
    </div>
    <div class="details__column--full">
      @if (order.containers && order.containers.length > 0) {
        <div class="details__column--label">Containers</div>
        @for (container of order.containers; track index; let index = $index) {
          <div>
            @if (container.containerExists) {
              <a [routerLink]="['/containers', container.containerNo]">{{ container.containerNo }}</a>
            } @else {
              <span>{{ container.containerNo }}</span>
            }
            {{ '' }}
            <span>{{ container.containerType }}</span>
          </div>
        }
      }
    </div>
    <app-departure class="details__column" [order]="order"></app-departure>
    <app-arrival class="details__column" [order]="order"></app-arrival>
  </div>
} @else {
  <app-details-skeleton></app-details-skeleton>
}
